import webAPIServices from "./webAPIServices";
import moment from "moment/moment";

export async function GetPurchaseReceipt(fecha) {
  const appsvc = new webAPIServices();

  const strFecha = appsvc.FormatFecha(
      fecha
  );
  
  console.log("GetPurchaseRecipt", strFecha);
  
  
  let requestUrl = `/backoffice/purchase/purchase-receipt/${strFecha}`;

  return appsvc.Get(requestUrl);
}

export async function PutPurchaseReceipt(itemChanged) {
  const appsvc = new webAPIServices();

  let requestUrl = `/backoffice/purchase/purchase-receipt`;

  return appsvc.Put(requestUrl, itemChanged);
}

export async function PostPurchaseReceipt(newItem) {
  const appsvc = new webAPIServices();

  if(!newItem || newItem.kilosSurtidos === "") newItem.kilosSurtidos = 0;
  
  console.log("newItem - post", newItem);

  let requestUrl = `/backoffice/purchase/purchase-receipt`;

  return appsvc.Post(requestUrl, newItem);
}

export async function GetPurchaseReceiptLookupProductos() {
  const appsvc = new webAPIServices();

  let requestUrl = `/backoffice/purchase/purchase-receipt/products`;

  return appsvc.Get(requestUrl);
}

export async function GetProveedores() {
  const appsvc = new webAPIServices();

  let requestUrl = `/backoffice/proveedores`;

  return appsvc.Get(requestUrl);
}

export async function GetPurchaseAnalysis(desde, hasta){
    const appsvc = new webAPIServices();
    const requestUrl = `/backoffice/purchase/analysis?desde=${appsvc.FormatFecha(desde)}&hasta=${appsvc.FormatFecha(hasta)}`;
        
    const response = await appsvc.Get(requestUrl);
     
    if (response && Array.isArray(response.details)) {
        response.details = response.details.map(item => ({
            ...item,
            fecha: appsvc.FormatFecha(item.fecha),
        }));
    }
    
    return response;
    
}

export async function GetMarginAnalysis(){
    const appsvc = new webAPIServices();
    const requestUrl = `/backoffice/purchase/margin-analysis`;     
    const response =  await appsvc.Get(requestUrl);
    console.log("response", response);
    return response;
}

export async function UpdateCostoDesdeUltimoCosto(idProducto) {
    const appsvc = new webAPIServices();

    let requestUrl = `/backoffice/purchase/actualizar-costo-desde-ultimo-costo/${idProducto}`;

    return appsvc.Post(requestUrl);
}

export async function GetPurchaseReceiptSummary(desde, hasta) {
  const appsvc = new webAPIServices();

  let requestUrl = `/backoffice/purchase/purchase-receipt/summary?desde=${appsvc.FormatFecha(
    desde
  )}&hasta=${appsvc.FormatFecha(hasta)}`;

  return appsvc.Get(requestUrl);
}

export async function GetPurchaseSuggested() {
  const appsvc = new webAPIServices();

  let requestUrl = `/backoffice/purchase/purchase-suggested`;

  return appsvc.Get(requestUrl);
}

export async function GetPurchaseSuggestedDetail(id) {
  const appsvc = new webAPIServices();

  let requestUrl = `/backoffice/purchase/purchase-suggested/${id}`;

  return appsvc.Get(requestUrl);
}

export async function PostPurchaseSuggested(idProducto, data) {
  const appsvc = new webAPIServices();

  let requestUrl = `/backoffice/purchase/purchase-suggested/${idProducto}`;

  return appsvc.Post(requestUrl, data);
}

export async function UpdateOrderNote(pedidoPartidaId, nota) {
  const appsvc = new webAPIServices();

  let requestUrl = `/backoffice/purchase/order-item-note/${pedidoPartidaId}`;

  return appsvc.Put(requestUrl, { nota });
}

export async function GetOrdenCompraNotas(proveedorId, fechaEntrega) {
  const appsvc = new webAPIServices();
  const requestUrl = `/backoffice/purchase/orden-compra-notas/${proveedorId}?fechaEntrega=${fechaEntrega}`;
  return appsvc.Get(requestUrl);
}

export async function SaveOrdenCompraNotas(proveedorId, fechaEntrega, notas) {
  const appsvc = new webAPIServices();
  const requestUrl = `/backoffice/purchase/orden-compra-notas/${proveedorId}?fechaEntrega=${fechaEntrega}`;
  return appsvc.Put(requestUrl, { notas });
}

export async function PostOrdenCompra() {
  const appsvc = new webAPIServices();
  return appsvc.Post(`/backoffice/Compras/corte-compras`);
}

export async function DeleteOrdenCompra(fecha) {
  const appsvc = new webAPIServices();
  return appsvc.Delete(`/backoffice/Compras/OrdenCompra?fecha=${fecha}`);
}

